import React, { useState } from 'react'
import { REQUEST_FORGOT_PASSWORD, UPDATE_FORGOT_PASSWORD, VERIFY_OTP } from '../Utils/apis';
const useVerifyOtp = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [sucess, setSucess] = useState(false);


    const submitOtp = async (email, otp) => {
        if (!loading) {
            try {
                setLoading(true)
                const res = await fetch(VERIFY_OTP, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email,
                        otp,
                    }),
                    credentials: 'include',
                });

                if (res.ok) {
                    // return Promise.resolve("Request Sended succesfully");
                    setSucess(true);
                }
                else {
                    const err = await res.json();
                    throw new Error(err.error);
                }
            } catch (error) {
                setError(error.message);
                return Promise.reject(error.message);
            }
            finally {
                setLoading(false);
            }
        }
    }

    return [loading, error, sucess, submitOtp];
}

export default useVerifyOtp;